import axios from 'axios'

function downloadFile(url, file, type, params) {
  const options = {
    headers: {'accept': type},
    responseType: 'blob',
    params
  };

  return axios.get(url, options).then(response => {
    const blob = new Blob([(response.data)], {type: type});
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.id = 'tmp-file-download';
    anchor.setAttribute('download', file);
    document.body.appendChild(anchor);
    anchor.click();
    document.getElementById(anchor.id).remove();
  });
}
export default {
  findAll: () => axios.get('/api/devices').then(resp => resp.data),
  findInStock: () => axios.get('/api/tablets/search/instock').then(resp => resp.data),
  setShop: (serialNumber, shopId, isMdm) => axios.patch(`/api/devices/${serialNumber}`, {shopId, isMdm}),
  add: (device) => axios.post(`api/tablets`, device),
  downloadCsv: () => downloadFile(`/api/devices`, 'dispositivi.csv', 'text/csv'),
  getLastVersion: () => axios.get('/api/application/sendVersion').then(resp => resp.data),
}
